import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { SolutionsSection } from '../components/SolutionsSection';
import { PricingSection } from '../components/PricingSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-453" />
      <ServicesSection data-id="element-454" />
      <SolutionsSection data-id="element-455" />
      <PricingSection data-id="element-456" />
    </>;
}